export default __webpack_public_path__ + "static/media/printeris.e02a2fa4.webp";